import { Spacing } from '@persona-id/design-tokens';
import MarkdownToJsx from 'markdown-to-jsx';
import { ComponentProps, FC, MouseEvent } from 'react';
import styled from 'styled-components';

const MARKDOWN_OPTIONS: ComponentProps<typeof MarkdownToJsx>['options'] = {
  disableParsingRawHTML: true,
  overrides: {
    // Make all anchor tags open in new window
    a: {
      component: styled.a``,
      props: {
        target: '_blank',
        rel: 'noreferrer',
        onClick: (e: MouseEvent<HTMLAnchorElement>) => {
          // People often want to put links inside checkbox labels which causes
          // a11y issues. This at least makes it behave less poorly by making
          // link clicks not change checkbox state.
          e.stopPropagation();
        },
      },
    },
  },
};

/**
 * This component is a thin wrapper around markdown-to-jsx, where we enforce
 * parsing raw HTML is disabled. The package markdown-to-jsx allows us convert
 * a string written in Markdown to JSX.
 */
const Markdown: FC<{ children: string }> = ({ children }) => {
  return (
    <Container>
      <MarkdownToJsx options={MARKDOWN_OPTIONS}>{children ?? ''}</MarkdownToJsx>
    </Container>
  );
};
export default Markdown;

const Container = styled.div`
  p + p,
  ol + p,
  ul + p {
    /* Add spacing between custom translation paragraphs */
    margin-top: ${Spacing[5]};
  }

  p + ol,
  p + ul,
  ol + ol,
  ol + ul,
  ul + ol,
  ul + ul {
    margin-top: 0.75rem;
  }

  /* To keep bullets within text margin */
  ol,
  ul {
    list-style-position: inside;
  }
`;
